import React from "react";
import Button from "@mui/material/Button";

interface ActionButtonProps {
  label: string;
  onClick: () => void;
  Icon: React.ReactNode;
}

export function ActionButton({ label, onClick, Icon }: ActionButtonProps) {
  return (
    <Button
      onClick={onClick}
      variant="contained"
      startIcon={Icon}
      sx={{
        textTransform: "none",
        backgroundColor: "#1BCF66",
        color: "#FFFFFF",
        "&:hover": {
          backgroundColor: "#18b85b",
        },
        "&:focus": {
          backgroundColor: "#1BCF66",
        },
        "&:active": {
          backgroundColor: "#15a852",
        },
      }}
    >
      {label}
    </Button>
  );
}